const COMPETITORS = [
  { name: 'Software de Inventario', price: 180000, icon: '📦', solo: true },
  { name: 'Software de Facturación', price: 120000, icon: '🧾', solo: true },
  { name: 'Agendamiento / CRM',      price: 130000, icon: '📅', solo: true },
];

const FEATURES = [
  { label: 'Control de inventario completo',      included: true },
  { label: 'Facturación y cuentas de cobro',      included: true },
  { label: 'Agendamiento y CRM de clientes',      included: true },
  { label: 'IA de compras inteligentes',          included: true },
  { label: 'Reportes financieros en tiempo real', included: true },
  { label: 'Vista cliente del vehículo en vivo',  included: true },
  { label: 'Historial clínico del vehículo',      included: true },
  { label: 'Landing page propia del taller',      included: true },
  { label: 'QR personalizado para clientes',      included: true },
  { label: 'Soporte y actualizaciones incluidos', included: true },
];

const TOTAL_COMPETITORS = COMPETITORS.reduce((sum, c) => sum + c.price, 0);
const PRICE_FULL   = 230000;
const PRICE_EARLY  = 130000;
const DISCOUNT_PCT = Math.round((1 - PRICE_EARLY / PRICE_FULL) * 100);
const SAVINGS      = PRICE_FULL - PRICE_EARLY;

const fmt = (n) => n.toLocaleString('es-CO');

const CheckIcon = () => (
  <svg className="w-5 h-5 text-orange-500 flex-shrink-0" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

const XIcon = () => (
  <svg className="w-5 h-5 text-red-400 flex-shrink-0" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

const Pricing = () => (
  <section id="precios" className="py-24 bg-zinc-950 relative overflow-hidden">

    {/* Fondo decorativo */}
    <div className="absolute inset-0 pointer-events-none">
      <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[700px] h-[400px] bg-orange-600/10 rounded-full blur-3xl" />
    </div>

    <div className="max-w-6xl mx-auto px-5 relative">

      {/* Encabezado */}
      <div className="text-center mb-16">
        <span className="inline-block bg-orange-600/20 text-orange-400 text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-4">
          Planes y Precios
        </span>
        <h2 className="text-4xl md:text-5xl font-black text-white leading-tight">
          Todo lo que tu taller necesita.<br />
          <span className="text-orange-500">En un solo lugar.</span>
        </h2>
        <p className="text-zinc-400 mt-4 text-lg max-w-xl mx-auto">
          Los talleres de la competencia pagan más de{' '}
          <span className="text-white font-bold">${fmt(TOTAL_COMPETITORS)}/mes</span>{' '}
          y todavía usan 3 apps distintas sin integración.
        </p>
      </div>

      {/* Comparativa */}
      <div className="grid md:grid-cols-2 gap-6 mb-12">

        {/* Columna: La competencia */}
        <div className="bg-zinc-900 border border-zinc-800 rounded-2xl p-6">
          <div className="flex items-center gap-3 mb-5">
            <div className="w-9 h-9 bg-red-500/15 rounded-lg flex items-center justify-center">
              <XIcon />
            </div>
            <div>
              <p className="text-white font-bold">Lo que hacen los demás</p>
              <p className="text-zinc-500 text-xs">Pagar 3 software por separado</p>
            </div>
          </div>
          <div className="space-y-3 mb-6">
            {COMPETITORS.map((c) => (
              <div key={c.name} className="flex items-center justify-between bg-zinc-800/60 rounded-xl px-4 py-3">
                <div className="flex items-center gap-2">
                  <span className="text-lg">{c.icon}</span>
                  <span className="text-zinc-300 text-sm">{c.name}</span>
                </div>
                <span className="text-red-400 font-bold text-sm">${fmt(c.price)}/mes</span>
              </div>
            ))}
          </div>
          <div className="border-t border-zinc-700 pt-4 flex items-center justify-between">
            <span className="text-zinc-400 text-sm">Total mensual</span>
            <div className="text-right">
              <p className="text-red-400 font-black text-2xl">${fmt(TOTAL_COMPETITORS)}<span className="text-sm font-normal">/mes</span></p>
              <p className="text-zinc-500 text-xs">Sin integración · Sin soporte unificado</p>
            </div>
          </div>
        </div>

        {/* Columna: Garaje Pro 360 */}
        <div className="bg-gradient-to-br from-orange-600 to-orange-800 rounded-2xl p-6 relative overflow-hidden shadow-2xl shadow-orange-900/50">
          <div className="absolute top-4 right-4">
            <span className="bg-white text-orange-700 text-xs font-black px-3 py-1 rounded-full shadow-lg">
              ⚡ LANZAMIENTO
            </span>
          </div>
          <div className="flex items-center gap-3 mb-5">
            <div className="w-9 h-9 bg-white/20 rounded-lg flex items-center justify-center">
              <svg className="w-5 h-5 text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="20 6 9 17 4 12" />
              </svg>
            </div>
            <div>
              <p className="text-white font-bold">Garaje Pro 360</p>
              <p className="text-orange-200 text-xs">Todo en uno · Un solo pago mensual</p>
            </div>
          </div>

          {/* Features lista */}
          <div className="space-y-2 mb-6">
            {FEATURES.map((f) => (
              <div key={f.label} className="flex items-center gap-2">
                <svg className="w-4 h-4 text-white flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
                <span className="text-white/90 text-sm">{f.label}</span>
              </div>
            ))}
          </div>

          <div className="border-t border-white/20 pt-4">
            <p className="text-orange-200 text-xs font-bold uppercase tracking-wider mb-2">Un solo precio mensual</p>
            <div className="flex items-end gap-3">
              <p className="text-white/50 line-through text-lg font-bold">${fmt(PRICE_FULL)}</p>
              <p className="text-white font-black text-4xl">${fmt(PRICE_EARLY)}<span className="text-base font-normal">/mes</span></p>
            </div>
            <p className="text-orange-200 text-sm mt-1">
              Ahorras <span className="text-white font-black">${fmt(SAVINGS)}/mes</span> — {DISCOUNT_PCT}% de descuento
            </p>
          </div>
        </div>
      </div>

      {/* Banner urgencia */}
      <div className="bg-zinc-900 border border-orange-600/40 rounded-2xl p-6 md:flex items-center justify-between gap-6 mb-8">
        <div className="flex items-start gap-4 mb-5 md:mb-0">
          <div className="text-3xl flex-shrink-0">🔥</div>
          <div>
            <p className="text-white font-black text-lg">Precio de lanzamiento — solo primeros 20 talleres</p>
            <p className="text-zinc-400 text-sm mt-1">
              Después de los 20 primeros registros el precio sube a{' '}
              <span className="text-white font-bold">${fmt(PRICE_FULL)}/mes</span>.{' '}
              Entra ahora y bloquea <span className="text-orange-400 font-bold">{DISCOUNT_PCT}% de ahorro permanente</span> mientras seas cliente activo.
            </p>
          </div>
        </div>
        <a
          href="#contacto"
          className="flex-shrink-0 inline-block bg-orange-600 hover:bg-orange-500 text-white font-black text-sm px-8 py-4 rounded-xl transition-all shadow-lg shadow-orange-900/40 whitespace-nowrap"
        >
          Registrar mi Taller →
        </a>
      </div>

      {/* Pie de sección */}
      <p className="text-center text-zinc-600 text-sm">
        Sin contratos de permanencia · Cancela cuando quieras · Soporte incluido
      </p>

    </div>
  </section>
);

export default Pricing;
